export default "__VITE_ASSET__DkZJJaWt__"